import { StarFilled } from '@finn/design-system/icons/star-filled';
import React from 'react';

interface IStyleProps {
  color?: string;
}

type Size = 'small' | 'medium' | 'large';
interface IProps extends IStyleProps {
  score: number;
  size?: Size;
}

const Star: React.FunctionComponent<IProps> = ({ score, color }) => {
  return (
    <>
      {Array.from({ length: 5 }).map((_, index) => {
        return (
          <StarFilled
            key={index}
            fill={index + 1 <= score / 2 ? (color ?? 'green') : 'grey'}
          />
        );
      })}
    </>
  );
};

export default Star;
